import { Mapper } from "../../../../base/utils/mapper";
import { TypeDocumentModel } from "../../../../domain/models/configuration/type-document.model";
import { TypeDocumentEntity } from "../entities/type-document.entity";

export class TypeDocumentImplementationRepositoryMapper extends Mapper<TypeDocumentEntity, TypeDocumentModel> {
    mapFrom(param: TypeDocumentEntity): TypeDocumentModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeDocumentModel): TypeDocumentEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}